module.exports = __webpack_public_path__ + "img/28_36.37176eac.png";